import { forwardRef } from 'react';

import type { InputHTMLAttributes } from 'react';
import type { Modify } from '@toolbox/utils';

export type HiddenInputProps<T extends string | number = string | number> = Modify<
  InputHTMLAttributes<HTMLInputElement>,
  {
    name: string;
    type?: 'string' | 'number' | 'boolean' | null;
    storyBlokValue: T;
    defaultValue?: T;
    onChange?: (value: T) => void;
  }
>;

export const HiddenInput = forwardRef<HTMLInputElement, HiddenInputProps>(function Switch(
  props,
  ref,
) {
  const { name, storyBlokValue } = props;

  return <input type={'hidden'} ref={ref} name={name} value={storyBlokValue} />;
});
